module.exports = {
    price: {
        en: "Price",
        fi: "Hinta"
    },
    location: {
        en: "Location",
        fi: "Sijainti"
    },
    address: {
        en: "Address",
        fi: "Osoite"
    },
    seller: {
        en: "Seller",
        fi: "Myyjä"
    },
    website: {
        en: "Website",
        fi: "Kotisivu"
    },
    contacts: {
        en: "Contacts",
        fi: "Yhteystiedot"
    },
    condition: {
        en: "Condition",
        fi: "Kuntotaso"
    },
    type: {
        en: "Type", 
        fi: "Tyyppi"
    },
    maker: {
        en: "Maker",
        fi: "Valmistaja"
    },
    subType: {
        en: "Sub type",
        fi: "Alityyppi"
    },
    frameSize: {
        en: "Frame size",
        fi: "Rungon koko"
    },
    gears: {
        en: "Gears",
        fi: "Vaihteisto"
    },
    material: {
        en: "Material",
        fi: "Materiaali"
    },
    breakType: {
        en: "Break type",
        fi: "Jarrujen tyyppi"
    },
    suspensionType: {
        en: "Suspension type",
        fi: "Jousituksen tyyppi"
    },
    gender: {
        en: "Gender",
        fi: "Sukupuoli"
    },
    numOfWheels: {
        en: "Number of wheels",
        fi: "Renkaiden lukumäärä"
    },
    wheelSize: {
        en: "Wheel size",
        fi: "Renkaiden koko"
    },
    tyreType: {
        en: "Tyre type",
        fi: "Renkaiden tyyppi"
    },
    mudGuardType: {
        en: "Mud guard type",
        fi: "Lokasuojan tyyppi"
    },
    rackType: {
        en: "Rack type",
        fi: "Tarakan tyyppi"
    },
    basketType: {
        en: "Basket type",
        fi: "Korin tyyppi"
    },
    isLockIncluded: {
        en: "Is lock included",
        fi: "Sisältyykö pyöränlukko kauppaan"
    },
    isFrontLightIncluded: {
        en: "Is front light included",
        fi: "Sisältyykö etuvalo kauppaan"
    },
    isRareLightIncluded: {
        en: "Is rare light included",
        fi: "Sisältyykö takavalo kauppaan"
    },
    legStandExists: {
        en: "Leg stand exists",
        fi: "Pyöränjalka"
    },
    color: {
        en: "Color",
        fi: "Väri"
    },
    sold: {
        en: "Sold",
        fi: "Myyty"
    },
    canceled: {
        en: "Canceled",
        fi: "Peruttu"
    }
};